import React from 'react';
import ReactDOM from 'react-dom/client';
// @ts-ignore: CSS module declarations not available in this project setup
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store'
import { Provider } from 'react-redux'
import MyThemeProvider from './theme/myThemeProvider';
import MyRoutes from './routes';
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license'; 


config({ licenseKey }); 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <>
    <MyThemeProvider>
      <Provider store={store}>
        <MyRoutes />
      </Provider>
    </MyThemeProvider>
  {/* </React.StrictMode> */}
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
